import React from "react";
import styled from "styled-components";

const MapContainer = styled.div`
  width: 100%;
  height: 500px;
  margin: 40px 0;
  border: 2px solid #ddd;
  border-radius: 8px;
  overflow: hidden;

  @media (max-width: 768px) {
    height: 300px;
  }
`;

const GoogleMapEmbed = ({ src, title }) => {
  return (
    <MapContainer>
      <iframe
        src={src}
        title={title}
        width="100%"
        height="100%"
        style={{ border: 0 }}
        allowFullScreen=""
        loading="lazy"
      ></iframe>
    </MapContainer>
  );
};

export default GoogleMapEmbed;
